module.exports = __webpack_public_path__ + "img/color_cafe-1.8a45fd5b.svg";